module.exports = __webpack_public_path__ + "img/logo.b57be023.png";